export default __webpack_public_path__ + "static/media/check_mark.c8dff184.png";